export default __webpack_public_path__ + "static/media/CAPANNONIPERSABBIATURAEVERNICIATURA.a3d0676b.pdf";